/* eslint-disable react-hooks/exhaustive-deps */
import React/* , { useEffect }  */from "react";
import { NavLink } from "react-router-dom";
import soldier from "../../../static/roman_soldier.png";
//import sign from "../../../static/sign.png";
import check from "../../../static/check.png";
import "./institution.scss";

export default function EndScreen({ backToTeam, history }) {
  /* useEffect(() => {
    setTimeout(() => {
      history.push("/");
    }, 30000);
  }, []); */

  return (
    <div>
      <div
        style={{
          position: "fixed",
          bottom: "0",
          left: "0",
          paddingTop: "2.65%",
          paddingLeft: "5%",
          backgroundImage: 'url("' + soldier + '")',
          height: "686px",
          width: "450px",
          backgroundSize: "cover",
        }}
      >
        {/*  <img alt="soldier" src={soldier} style={{}} /> */}
      </div>
      <div style={{ textAlign: "center", marginTop: "25px" }}>
        <img
          src={check}
          alt="check"
          style={{ width: "100px", height: "auto" }}
        />
      </div>
      <div
        style={{ width: "34%", margin: "0 auto" }}
        className="free-end-start-adventure"
      >
        Indulhat a kaland!
      </div>
      <p
        style={{ width: "34%", margin: "0 auto" }}
        className="free-end-start-adventure-subtext"
      >
        A regisztrációd sikeres, kalandozásaid során ne feledd használni a
        kapott QR kódodat!
      </p>
      <div
        style={{
          margin: "0 auto",
          width: "33%",
          paddingTop: "15px",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        <div>
          <button className="inst-block-button" onClick={backToTeam}>
            Még egy csapatot szeretnék létrehozni!
          </button>
        </div>
        <div>
          <NavLink to="/">
            <button className="inst-block-button">Befejezés</button>
          </NavLink>
        </div>
      </div>
    </div>
  );
}
